module.exports = __webpack_public_path__ + "media/long-rythmic-clapping.82c84863.mp3";